@if (_currentData.resouceDef) {
  <div class="main-content-container">
    <div [ngClass]="showGridOnly ? '' : 'main-container-body'">
      <!-- change here due dhs form grid action shows banner two times on the screen please review by saurav deep -->
      @if (_currentData.showBanner && !showGridOnly && _currentData.currentAction != 'FORM_GRID') {
        <div>
          @if (_currentData.bannerJson.component == undefined) {
            <app-resource-banner [bannerJson]="_currentData.bannerJson"></app-resource-banner>
          }
        </div>
      }
      @if ((_currentData != undefined && _currentData.currentAction == 'LIST' && _currentData.tabConfig !=undefined &&  _currentData.tabConfig.list_back_navigation === true ? true : false) ||
        (_layout == 'simple' && !showGridOnly) || (_layout == 'simple')) {
        <div class="page-title-container d-flex">
          @if (_currentData != undefined && _currentData.currentAction == 'LIST' && _currentData.tabConfig !=undefined &&  _currentData.tabConfig.list_back_navigation === true ? true : false) {
            <div class="page-title flex-grow-1">
              <a class="d-inline-flex" href="javascript:void(0)" (click)="listResource()">
                <img src="assets/images/grid-back.png" />
              </a>
              {{baseService._currentTitle}}
            </div>
          }
          @if (_layout == 'simple' && !showGridOnly) {
            <div class="page-title flex-grow-1">
              @if (_currentData.currentAction == 'LIST') {
                <div class="mb-0">
                  @if (_layout_data.config != undefined && _layout_data.config.list_back_navigation === true ? true : false) {
                    <div class="pl-2 pr-2">
                      <a class="d-inline-flex" href="javascript:void(0)" (click)="listResource()">
                        <img src="assets/images/grid-back.png" />
                      </a>
                      {{baseService._currentTitle}}
                    </div>
                  } @else {
                    {{baseService._currentTitle}}
                  }
                </div>
              }
              @if (_currentData.currentAction != 'LIST') {
                <div class="mb-0">
                  <div class="d-flex align-items-center">
                    @if (_layout_data.config != undefined && _layout_data.config.back_navigation === false ? false : true) {
                      <div class="pl-2 pr-2">
                        <a class="d-inline-flex" href="javascript:void(0)" (click)="listResource()">
                          <img src="assets/images/grid-back.png" />
                        </a>
                      </div>
                    }
                    <div class="">
                      {{baseService._currentTitle}}
                    </div>
                  </div>
                </div>
              }
            </div>
          }
          @if (_layout == 'simple') {
            <div class="component-container">
              @if ((_currentData.currentAction == 'LIST' || _currentData.currentAction == 'IMAGE_VIEWER') && rolePermissionService.checkAccessPermission('add') && _currentData.addAllowed) {
                <div class="">
                  <ng-container [ngTemplateOutlet]="addRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
                  </ng-container>
                  <ng-container [ngTemplateOutlet]="switchRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
                  </ng-container>
                </div>
              }
            </div>
          }
        </div>
      }
      @if (_layout == 'simple') {
        <div class="main-box-shadow layout_simple layout_simple_{{_currentData.currentResource}}">
          <ng-container [ngTemplateOutlet]="layoutRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
          </ng-container>
        </div>
      }
      @if (_layout == 'tab') {
        <div class="layout_tab layout_tab_main_{{_currentData.json}} layout_tab_{{_layout_id}}">
          @if (_currentData.tabType == 'horizontal') {
            <div class="layout_tab_horizontal layout_tab_horizontal_{{_layout_id}}">
              <!---action button in case of Tabs : added by abhinav chauhan-->
              <!-- <div class="d-flex justify-content-end" *ngIf="_currentData.currentAction == 'LIST' && rolePermissionService.checkAccessPermission('add', _currentData.resource) && _currentData.addAllowed">
              <ng-container [ngTemplateOutlet]="addRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
              </ng-container>
            </div> -->
            <!-- <ul class="nav nav-tabs kx-tabs"> -->
            <ul class="base-tab" id="tab_{{_currentData.json}}" #tabWidth_ [ngClass]="{'tabWithoutButtons':!(tab_+_currentData.json | getHeight:tabWidth:'tabWidth')}">
              @if ((tab_+_currentData.json | getHeight:tabWidth:'tabWidth') | async) {
                <div class="scroll-btn-move scroll-btn-move-prev">
                  <div class="_tab-expand" (click)="toggleTabView($event)">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                    <i class="fa fa-chevron-up" aria-hidden="true"></i>
                  </div>
                  <div class="tab-prev tab-scroll-actions" (click)="scrolltab('tab_'+_currentData.json,'right')">
                    <div class="tab-prev-circle">
                      <i class="fa fa-angle-left" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
              }
              @for (layout_key of _layout_data | keys; track layout_key) {
                <li class="nav-item">
                  <a class="nav-link" [ngClass]="layout_key == _layout_id ? 'active' : ''"
                    (click)="activeTab(layout_key)" data-toggle="tab" id="{{layout_key}}"
                  role="tab">{{_layout_data[layout_key]['data']['layoutName'] | translate | async }}</a>
                </li>
              }
              @if (tab_+_currentData.json | getHeight:tabWidth:'tabWidth') {
                <div class="scroll-btn-move">
                  <div class="tab-next tab-scroll-actions">
                    <div class="tab-prev-circle" (click)="scrolltab('tab_'+_currentData.json,'left')">
                      <i class="fa fa-angle-right" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
              }
            </ul>
            @if (this._currentData.render_template) {
              <div class="base-tab-content" id="_layout_id">
                <!---action button in case of Tabs : added by abhinav chauhan-->
                @if (_currentData.currentAction == 'LIST' && rolePermissionService.checkAccessPermission('add', _currentData.resource) && _currentData.addAllowed) {
                  <div class="d-flex justify-content-end">
                    <ng-container [ngTemplateOutlet]="addRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
                    </ng-container>
                    <ng-container [ngTemplateOutlet]="switchRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
                    </ng-container>
                  </div>
                }
                <ng-container [ngTemplateOutlet]="layoutRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
                </ng-container>
              </div>
            }
          </div>
        }
        @if (_currentData.tabType == 'vertical') {
          <div class="row layout_tab_vertical layout_tab_vertical_{{_layout_id}}">
            <div class="v-tab-action-container">
              <div class="nav flex-column nav-pills" role="tablist" aria-orientation="vertical">
                @for (layout_key of _layout_data | keys; track layout_key) {
                  <a class="nav-link kx-v-tab" [ngClass]="layout_key == _layout_id ? 'active show' : ''" data-toggle="pill" id="{{layout_key}}" role="tab" (click)="activeTab(layout_key)">{{_layout_data[layout_key]['data']['layoutName'] | translate | async }}</a>
                }
              </div>
            </div>
            <div class="v-tab-container">
              @if (_currentData.currentAction == 'LIST' && rolePermissionService.checkAccessPermission('add', _currentData.resource) && _currentData.addAllowed) {
                <div class="kx-action-on-card">
                  <ng-container [ngTemplateOutlet]="addRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
                  </ng-container>
                  <ng-container [ngTemplateOutlet]="switchRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
                  </ng-container>
                </div>
              }
              <div class="tab-content" id="v-pills-tabContent">
                @if (this._currentData.render_template) {
                  <div class="tab-pane kx-v-tab-pane fade active show" id="_layout_id">
                    @if (_currentData.resouceDef.child_tab) {
                      <div>
                        <app-ui-engine [resourcename]="_currentData.resouceDef.child_tab"></app-ui-engine>
                      </div>
                    } @else {
                      <ng-container [ngTemplateOutlet]="layoutRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
                      </ng-container>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }
    <ng-template #switchRenderer let-_currentData='_currentData'>
      @if (_currentData.currentAction == 'LIST' && _currentData.config.tile && _currentData.config.table  && !utilService.isMobile()) {
        <div class="table-view-toggle">
          <span _ngcontent-pbu-c8="" class="toggle-icn">
            @if (_currentData.config.activeField == 'table') {
              <i _ngcontent-pbu-c8="" aria-hidden="true" class="fa fa-th" (click)="switchView('tile');"></i>
            }
            @if (_currentData.config.activeField == 'tile') {
              <i _ngcontent-pbu-c8="" aria-hidden="true" class="fa fa-list" (click)="switchView('table');"></i>
            }
          </span>
        </div>
      }
    </ng-template>
    <ng-template #addRenderer let-_currentData='_currentData'>
      <!--button in case of grid : added by abhinav chauhan-->
      @if (_currentData.addButton == undefined && !showGridOnly) {
        <button class="primary-btn" (click)="addResource()">
          <span>{{'button.add' | translate | async }}</span>
          <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
      }
      @if (_currentData.addButton != undefined && _currentData.addButton.type == 'button') {
        @if (_currentData.showAddButton) {
          <button class="primary-btn" (click)="addResource(_currentData.addButton)">
            <span>{{_currentData.addButton.label | translate | async }}</span>
            <i class="fa fa-plus" aria-hidden="true"></i>
          </button>
        }
      }
      @if (_currentData.addButton != undefined && _currentData.addButton.type == 'search') {
        @if (_currentData.showAddButton) {
          <button class="primary-btn" type="button" (click)="addButtonAction();">
            <span>{{_currentData.addButton.label | translate | async}}</span>
            <i class="fa fa-plus-circle" aria-hidden="true"></i>
          </button>
        }
        @if (!_currentData.showAddButton) {
          <div class="inputSearchElementcontainer" style="z-index:2; position:relative; width:400px;">
            <input-search id="inputSearchElement" [data]="_currentData.addButton" [placeholder]="_currentData.addButton.hint" (patientResult)="settingUserInfo($event)" (labelEvent)="InputEvent(event);" (closeOverlay)="closesOverlay();">
          </input-search>
        </div>
      }
      @if (!_currentData.showAddButton) {
        <div class="cstmOverlay"></div>
      }
    }
  </ng-template>
  <ng-template #layoutRenderer let-_currentData='_currentData'>
    @if (_currentData.currentAction === 'EDIT_GRID') {
      <div>
        <kx-editable-grid [resourceName]="_currentData.resouceDef.resource"> </kx-editable-grid>
      </div>
    }
    @if (_currentData.currentAction === 'EDITGRID') {
      <div>
        <kx-editable-grid-with-banner [resource]="_currentData.resouceDef.resource"> </kx-editable-grid-with-banner>
      </div>
    }
    <!-- Form and grid both render -->
    @if (_currentData.currentAction === 'FORM_GRID') {
      <div>
        <dhs-form-grid (bulkActionClicked)="onBulkActionClicked($event)" [resourceName]="_currentData.resouceDef.resource" (editEllipseClick)="buttonAction($event)"></dhs-form-grid>
      </div>
    }
    @if (_currentData.currentAction === 'IMAGE_VIEWER') {
      <div>
        <app-document-viewer [resourceName]="_currentData.resouceDef.resource"></app-document-viewer>
      </div>
    }
    <!-- <div class="row" *ngIf="_currentData.currentAction == 'LIST' && _currentData.config.tile && _currentData.config.table">
    <div class="col-12 mb-1 switch-view-container">
      <div class="d-flex mb-1 float-right">
        <button class="switch-view" [ngClass]="_currentData.config.activeField == 'table' ? 'active': ''" *ngIf="_currentData.config.table" (click)="switchView('table');"><i
        class="fa fa-list"></i></button>
        <button class="switch-view" [ngClass]="_currentData.config.activeField == 'tile' ? 'active': ''" *ngIf="_currentData.config.tile" (click)="switchView('tile');"><i class="fa fa-th"></i></button>
      </div>
    </div>
  </div> -->
  <div class="">
    <!-- {{_currentData.currentFormFields | json}} -->
    @if (_currentData.currentAction === 'ADD') {
      <dhs-form [action]="_currentData.currentAction" [data]="_currentData.defaultFormData" [fieldGroup]="_currentData.currentFormFields" [config]="_currentData.configForm"
        [decorator]="_currentData.decorator" [customButton]="_currentData.customButton" (saveFinished)="onSaveFinished($event)"   #formComponenet>
      </dhs-form>
    }
    @if (_currentData.currentData && _currentData.currentAction === 'MODIFY') {
      <dhs-form [action]="_currentData.currentAction" [fieldGroup]="_currentData.currentFormFields" [config]="_currentData.configForm" [data]="_currentData.currentData" (saveFinished)="onSaveFinished($event)"
        [decorator]="_currentData.decorator" [customButton]="_currentData.customButton"   #formComponenet>
      </dhs-form>
    }
    @if (_currentData.currentData && _currentData.currentAction === 'VIEW') {
      <dhs-form-view [fieldGroup]="_currentData.currentFormFields" [data]="_currentData.currentData">
      </dhs-form-view>
    }
  </div>
  @if (_currentData.dataList != null && _currentData.showView) {
    <div>
      @if (_currentData.currentAction === 'LIST' || _currentData.currentAction === 'VIEW_DETAILS') {
        <dhs-data-grid [fields]="_currentData.currentListFields" [filterFieldGroup]="_currentData.currentFilterListFormFields" [data]="_currentData.dataList" [bulkActionsConfig]="_currentData.bulkAction"
          [rowClick]="_currentData.rowClick" (bulkActionClicked)="onBulkActionClicked($event)" (bindGrid)="bindDataToGrid($event)" (onLimitChange)="limitChanged($event)" (onFilterChange)="filterChange($event)" (editEllipseClick)="buttonAction($event)"
          (configValues)="getConfigValues($event)" (onPageChanges)="pageChanges($event)" (onSortChanges)="sortChanges($event);" [config]="_currentData.dataGridConfig">
        </dhs-data-grid>
      }
    </div>
  }
  <ng-template #customComponent>
  </ng-template>
</ng-template>
</div>
</div>
}
<div dhs-modal></div>